import type { RailingStyle } from "../adapters/types";

export const RAILING_STYLES: RailingStyle[] = ["glass", "glass-high", "mesh", "bars", "wood", "wood-white", "hedge", "hedge-high"];

export function isRailingStyle(value: unknown): value is RailingStyle {
  return RAILING_STYLES.includes(value as RailingStyle);
}
